import React from "react";
import styled from "styled-components";
import Layout from "components/Layout";

const SignInMessage = () => {
  return (
    <Layout>
      <Msg>Tryk på start for at komme i gang!</Msg>
    </Layout>
  );
};

const Msg = styled.div`
  padding: 2em;
  margin: 2em 4em;
  border: 1px solid ${(props) => props.theme.color.middle_blue};
  color: ${(props) => props.theme.color.dark_electric_blue};
`;

export default SignInMessage;
